// Status do lance na Servopa: tipos, categoria e a frase amigável do erro.
// Lógica pura, usada pela tela (LanceStatusBadge) e pelo motor no servidor.

export type LanceStatus =
  | 'simulated'
  | 'registered'
  | 'already_placed'
  | 'cancelled'
  | 'failed'
  | 'pending'
  | 'contemplado'
  | null
  | undefined;

/**
 * Consolidated category — shown to user. Internally servopa_lances tem mais
 * statuses, mas a UI agrupa em 5 buckets (contemplado tem o seu próprio).
 */
export type LanceCategory = 'ok' | 'pendente' | 'falha' | 'nao_disponivel' | 'contemplado';

export function lanceStatusCategory(status: LanceStatus): LanceCategory {
  switch (status) {
    case 'contemplado':
      return 'contemplado';
    case 'simulated':
    case 'registered':
    case 'already_placed':
      return 'ok';
    case 'failed':
      return 'falha';
    case 'cancelled':
      return 'nao_disponivel';
    case 'pending':
    case null:
    case undefined:
    default:
      return 'pendente';
  }
}

/**
 * Mapeia o error_message técnico do Servopa pra uma frase amigável.
 * Match em lowercase pra ser robusto a variações (maiúsculas, acentos).
 */
export function friendlyTooltip(rawError: string | null | undefined): string | null {
  if (!rawError) return null;
  const t = rawError.toLowerCase();
  if (t.includes('contemplada')) {
    return 'Cota já contemplada. Lance indisponível.';
  }
  if (t.includes('somente por sorteio') || t.includes('só sorteio') || t.includes('contemplação somente')) {
    return 'Grupo só aceita sorteio nesta assembleia.';
  }
  if (t.includes('grupo não permite lance fixo') || t.includes('grupo nao permite lance fixo')) {
    return 'Grupo não aceita Lance Fixo nesta assembleia.';
  }
  if (t.includes('grupo não permite') || t.includes('grupo nao permite')) {
    return 'Grupo não aceita esse tipo de lance nesta assembleia.';
  }
  if (t.includes('only livre tab') || t.includes('só livre') || t.includes('apenas livre')) {
    return 'Grupo só aceita Lance Livre, fora do fluxo automático.';
  }
  if (t.includes('fidelidade não elegível') || t.includes('fidelidade nao elegivel')) {
    return 'Cliente ainda não é elegível para Lance Fidelidade (requer mais parcelas pagas em dia).';
  }
  if (t.includes('valida_protocolo') || t.includes('protocolo anterior')) {
    return 'Cota já possui lance nesta assembleia; a automação não o substitui (a Servopa exige o protocolo original).';
  }
  if (t.includes('já registrado') || t.includes('tp_lance=e')) {
    return 'Lance já registrado nesta assembleia (feito manualmente ou em outra automação).';
  }
  if (t.includes('detached frame') || t.includes('connection closed')) {
    return 'Erro temporário na automação. Nova tentativa na próxima execução.';
  }
  // fallback: usa o texto original truncado
  return rawError.length > 200 ? rawError.slice(0, 200) + '…' : rawError;
}
